import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowRight, Sparkles, Lock } from 'lucide-react';
import { Button } from '../components/ui/button';

// Dashboard banner for free-plan users
export const UpgradeBanner = ({ plan }) => {
  const navigate = useNavigate();
  if (plan && plan !== 'free') return null;

  return (
    <div className="mb-6 bg-gradient-to-r from-purple-600 via-pink-500 to-orange-400 rounded-xl p-4 sm:p-5 shadow-lg" data-testid="upgrade-banner">
      <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
        <div className="flex items-center gap-3">
          <div className="bg-white/20 backdrop-blur-sm rounded-lg p-2">
            <Sparkles className="w-5 h-5 text-yellow-200" />
          </div>
          <div>
            <p className="text-white font-semibold text-sm sm:text-base">
              Upgrade to unlock unlimited projects & full reports
            </p>
            <p className="text-white/80 text-xs sm:text-sm mt-0.5">
              7-day free trial on all plans. No charge today.
            </p>
          </div>
        </div>
        <Button
          onClick={() => navigate('/pricing')}
          className="bg-white text-purple-700 hover:bg-yellow-50 font-semibold shadow-md text-sm shrink-0"
          data-testid="upgrade-banner-cta"
        >
          Start Free Trial <ArrowRight className="w-4 h-4 ml-1" />
        </Button>
      </div>
    </div>
  );
};

// In-tool limit prompt (shown when hitting usage limits)
export const ToolLimitPrompt = ({ feature, plan }) => {
  const navigate = useNavigate();
  if (plan && plan !== 'free') return null;

  return (
    <div className="mt-4 bg-amber-50 dark:bg-amber-900/20 border border-amber-200 dark:border-amber-800 rounded-lg p-4" data-testid="tool-limit-prompt">
      <div className="flex items-start gap-3">
        <Lock className="w-5 h-5 text-amber-600 dark:text-amber-400 shrink-0 mt-0.5" />
        <div>
          <p className="text-sm font-medium text-amber-800 dark:text-amber-300">
            {feature || 'This feature'} is limited on the Free plan
          </p>
          <p className="text-xs text-amber-600 dark:text-amber-400 mt-1">
            Upgrade to get unlimited access, full PDF reports, and DocuSign integration.
          </p>
          <Button
            variant="outline"
            size="sm"
            onClick={() => navigate('/pricing')}
            className="mt-2 border-amber-300 text-amber-700 hover:bg-amber-100 dark:border-amber-600 dark:text-amber-300 dark:hover:bg-amber-900/30"
            data-testid="tool-limit-upgrade-btn"
          >
            View Plans <ArrowRight className="w-3.5 h-3.5 ml-1" />
          </Button>
        </div>
      </div>
    </div>
  );
};
